import React, { useCallback } from 'react'
import ModalFrameHoc from 'components/Modal/modalFrameHoc'
import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styles from './onboarding-modal.module.scss'
import { getOnboardingButtonProps } from '../../utils/onboardingButtonProps'
import {
  pointerEventBubbleHandlers,
  withStoppedPointerEventBubble,
} from '../../utils/stopPointerEventBubble'

const OnboardingModal = (props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { UUID, card, closeModal } = props

  const close = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleClick = useCallback(
    (button) => {
      dispatch({ type: 'ONBOARDING_MODAL/BUTTON_CLICK_' + UUID, payload: button })
      if (button.action !== 'confirm-interrupt') {
        close()
      }
    },
    [UUID, dispatch, close],
  )

  const handleButtonClick = useCallback(
    (button) => withStoppedPointerEventBubble(() => handleClick(button)),
    [handleClick],
  )

  return (
    <ModalFrameHoc
      {...props}
      className={styles['modal-content']}
      closeModal={close}
      showCloseButton={false}
      noHeader
    >
      <Grid
        direction={'column'}
        gap={16}
        {...pointerEventBubbleHandlers}
      >
        {!card?.hideCloseButton && (
          <Button
            noHover
            className={styles['close-button']}
            variant={'ghost'}
            grey
            color={'Label-Onsurface'}
            onClick={handleButtonClick({ action: 'confirm-interrupt' })}
            startIcon={<Icon name={'close'} />}
            noLabel
          />
        )}

        {card?.title && (
          <Typography
            variant="Subtitle-20"
            noMargin
          >
            {t(card.title)}
          </Typography>
        )}

        {card?.description && (
          <Typography
            variant="Body-20"
            noMargin
            className={styles['description']}
          >
            {t(card.description)}
          </Typography>
        )}

        {card?.buttons && card.buttons.length > 0 && (
          <div className={styles['buttons']}>
            {card.buttons.map((button, index) => (
              <Button
                key={index}
                {...getOnboardingButtonProps(button, index)}
                onClick={handleButtonClick(button)}
              >
                {t(button.label)}
              </Button>
            ))}
          </div>
        )}
      </Grid>
    </ModalFrameHoc>
  )
}

OnboardingModal.propTypes = {
  UUID: PropTypes.string,
  card: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        action: PropTypes.oneOf([
          'next',
          'navigate',
          'close',
          'complete',
          'completeBranch',
          'finalize',
          'confirm-interrupt',
          'interrupt',
        ]).isRequired,
        branchId: PropTypes.string,
        url: PropTypes.string,
        variant: PropTypes.string,
      }),
    ),
  }),
  closeModal: PropTypes.func,
}

export default OnboardingModal
